"use client";

import type { IconicVoiceItem } from "@/app/_api/elevenlabs/iconicVoices";

import dynamic from "next/dynamic";

const IconicVoicesTable = dynamic(() => import("./IconicVoicesTable").then(mod => mod.IconicVoicesTable));

interface IconicVoicesTableClientProps {
  title?: string | null;
  searchPlaceholder?: string | null;
  voices: IconicVoiceItem[];
}

export const IconicVoicesTableClient = (props: IconicVoicesTableClientProps) => {
  return <IconicVoicesTable {...props} />;
};
